import { APP_API_URL } from '../../utils/xhr-instance';
import axiosInstance from '../axios';

export async function updateAutoGeneratedPurchaseOrderNumber(body) {
	try {
		const token = localStorage.getItem('authToken');
		const { data } = await axiosInstance.put(
			`${APP_API_URL}/user/auto-generated-purchase-order`,
			body,
			{
				headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${token}`,
				},
			},
		);

		if (data.code === 422) {
			throw new Error(data.message[0].message);
		}
		return data?.data;
	} catch (error) {
		throw error;
	}
}
